const entityState = (state, entityType) =>
  state?.settings?.archiveStatuses?.[entityType];

export const buildArchiveStatusSelectors = (entityType) => ({
  selectItems: (state) => entityState(state, entityType)?.statuses || [],
  selectEditableItems: (state) =>
    entityState(state, entityType)?.editableStatuses || [],
  selectIsLoading: (state) => Boolean(entityState(state, entityType)?.isLoading),
  selectIsEditing: (state) => Boolean(entityState(state, entityType)?.isEditing),
  selectIsDirty: (state) => Boolean(entityState(state, entityType)?.isDirty),
  selectIsLocked: (state) => Boolean(entityState(state, entityType)?.isLocked),
  selectLockedBy: (state) => entityState(state, entityType)?.lockedBy || "",
});

export const selectIsAnyArchiveStatusListEditing = (state) =>
  Object.values(state?.settings?.archiveStatuses || {}).some(
    (entity) => entity.isEditing
  );
